
export async function uploadImageFromUrl(url) {
    const blob = await getBlobAsync(url);

    await uploadImageAsync(blob);
}

export async function uploadImageFromExistingImgElementAsync(projectUniqueCode, imgEl) {
    const blob = await getBlogFromImgAsync(imgEl);

    await uploadImageAsync(projectUniqueCode, blob);
}

export function getBlobAsync(url) {
    return new Promise((resolve) => {
        const img = new Image;
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");

        img.onload = function () {
            c.width = this.naturalWidth; // update canvas size to match image
            c.height = this.naturalHeight;
            ctx.drawImage(this, 0, 0); // draw in image
            c.toBlob(function (blob) { // get content as JPEG blob
                resolve(blob);
            }, "image/png", 1);
        };
        img.crossOrigin = ""; // if from different origin
        img.src = url;
    });
}

export async function getBlogFromImgAsync(imgElement) {
    return new Promise((resolve) => {
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");

        c.width = imgElement.naturalWidth; // update canvas size to match image
        c.height = imgElement.naturalHeight;
        ctx.drawImage(imgElement, 0, 0); // draw in image
        c.toBlob(function (blob) { // get content as JPEG blob
            resolve(blob);
        }, "image/png", 1);

    });
}

export async function uploadImageAsync(projectUniqueCode, blobOrUrl) {
    if (typeof blobOrUrl === 'string') {
        var url = blobOrUrl;
        var isUrl = true;
    } else {
        var blob = blobOrUrl;
        var isUrl = false;
    }

    const file = new File([blob], "projecticon", {
        type: 'image/png'
    });

    var fd = new FormData();
    fd.append("file", file);

    const signal = new AbortController();

    setTimeout(() => {
        signal.abort();
    }, 3000);

    /*const respo = */await fetch(`/api/v1/projects/${projectUniqueCode}/general/avatar?url=${url}`, {
        method: 'post',
        body: !isUrl ? fd : null,
        signal: signal.signal
    });
}
